

import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface PathSelectionStepProps {
  onSelectCipher: () => void;
  onSelectTwitter: () => void;
  hasToken: boolean;
}

const PathSelectionStep = ({ onSelectCipher, onSelectTwitter, hasToken }: PathSelectionStepProps) => {
  return (
    <div className="text-center space-y-6">
      <h2 className="text-2xl font-patrick text-tan">Choose Your Path to Brotherhood</h2>
      <p className="text-lg text-tan">Select how you'd like to earn your BroCode</p>

      <div className="grid gap-6 max-w-4xl mx-auto">
        {/* Cipher Path */}
        <div className="bg-navy-dark p-6 rounded-lg border border-tan-dark">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-xl font-bold text-tan">The Cipher Challenge</h3>
            <Badge variant="outline" className="border-tan text-tan">Most Popular</Badge>
          </div>
          <p className="text-tan-dark mb-4">
            Test your knowledge and wit with our challenging cipher quiz. Prove you understand the BroMENtum principles.
          </p>
          <div className="space-y-2 mb-4">
            <p className="text-sm text-tan">• Rank: Initiated Bro or Shadow Bro</p>
            <p className="text-sm text-tan">• Reward: 50-150 BroScore</p>
            <p className="text-sm text-tan">• Time: 10-15 minutes</p>
          </div>
          <Button 
            onClick={onSelectCipher}
            className="w-full bg-tan text-navy-dark hover:bg-tan-dark"
          >
            Take the Cipher Challenge
          </Button>
        </div>

        {/* Twitter Engagement Path */}
        <div className="bg-navy-dark p-6 rounded-lg border border-tan-dark">
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-xl font-bold text-tan">Social Engagement</h3>
            <Badge variant="outline" className="border-green-500 text-green-500">New</Badge>
          </div>
          <p className="text-tan-dark mb-4">
            Share our mission on Twitter and become a Social Bro. Help spread the BroMENtum movement!
          </p>
          <div className="space-y-2 mb-4">
            <p className="text-sm text-tan">• Rank: Social Bro</p>
            <p className="text-sm text-tan">• Reward: 35 BroScore</p>
            <p className="text-sm text-tan">• Time: 5 minutes</p>
            <p className="text-sm text-tan">• Requirement: Twitter account</p>
          </div>
          <Button 
            onClick={onSelectTwitter}
            className="w-full bg-tan text-navy-dark hover:bg-tan-dark"
          >
            Start Social Engagement
          </Button>
        </div>

      </div>

      {!hasToken && (
        <div className="mt-6 p-4 bg-navy-light rounded-lg border border-tan-dark max-w-md mx-auto">
          <p className="text-sm text-tan">
            <strong>Pro Tip:</strong> TOP1 token holders get enhanced benefits and unlimited attempts!
          </p>
        </div>
      )}
    </div>
  );
};

export default PathSelectionStep;
